/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import { Modal } from 'shared'
import ModalDonateTicketNftStyled from './styled'
import { notification } from 'antd'
import Button from 'shared/Button'
import { CLOSE_BTN, LINE_GUILD_GRADIENT, TWO_LINE } from 'assets/images'
import { useTranslation } from 'react-i18next'
import { GUILD_MESSAGE, LENDING_MESSAGE, NOTIFICATION_MESSAGE } from 'i18n/constants'
import { NUMBER, STATUS_TRANSACTION, STRING, timeCheckNonce } from 'apps/constants'
import { checkAnyWalletEnabled, convertGasPrice, getGasPriceOption, handleAsyncRequest, removeDataAtLocalStorage } from 'utils/helper'
import guildApi from 'apis/guildApi'
import { useAppDispatch, useAppSelector, useReloadCurrentPage, useToggle, useUpdateEffect } from 'hooks'
import InProgressBalanceModal from 'features/Balance/components/InProgress'
import itemApi from 'apis/itemApi'
import { GetRaceListParams } from 'models'
import { RaceTable } from 'features/Race/components'
import { guildDonateTicketColumns } from 'utils/columns'
import ReactPaginate from 'react-paginate'
import { useAvailableWallet } from 'features/Auth/pages/Main/useAvailableWallet'
import { BigNumber, ethers } from 'ethers'
import { configs, links } from 'apps'
import ticketNftABI from 'json/TicketNFT.json'
import guildVaultABI from 'json/GuildVault.json'
import { getTicketList } from 'apps/redux/userCreateRace/action'
import { useNavigate } from 'react-router-dom'
import ModalConfirm from 'features/Guild/components/ModalConfirmEditGuild'

interface ModalProps {
  toggleIsModalOpen: (value?: boolean) => void
  onCloseButtonClick: () => void
  onConfirmDonate: () => void
}

interface ResultDonate {
  adil_amount: number
  block_expired: number
  gas_price: number
  guild_id: number
  item_ids: number[]
  nonce: string
  ticket_amounts: number[]
  ticket_ids: number[]
  r: string
  s: string
  v: number
}

interface RequestDonate {
  guildId: string
  blockExpired: string
  itemIds: number[] | null
  ticketIds: number[] | null
  ticketAmounts: number[] | null
  adilAmount: BigNumber
  nonce: string | null
  r: string
  s: string
  v: number
}

const defaultParams: GetRaceListParams = {
  limit: NUMBER.TWENTY,
  page: NUMBER.ONE
}

const contract = {
  tokenGuildVault: configs.guildVault
}

export default function DonateTicket({ onCloseButtonClick, onConfirmDonate }: ModalProps) {
  const [api, contextHolder] = notification.useNotification()
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const { t } = useTranslation()
  const { profile } = useAppSelector(state => state)
  const [openInProgressBalanceModal, toggleOpenInProgressBalanceModal] = useToggle(false)
  const [dataItems, setDataItems] = useState<any>([])
  const [params, setParams] = useState<GetRaceListParams>(defaultParams)
  const [loading, setLoading] = useState<boolean>(false)
  const [total, setTotal] = useState()
  const [tokenIds, setTokenIds] = useState<number[]>([])
  const dispatch = useAppDispatch()
  const providers = useAvailableWallet()
  const storedWalletName = localStorage.getItem('walletName')
  const navigate = useNavigate()
  const [isConfirm, setIsConfirm] = useState(false)
  const [isConfirmMulti, setIsConfirmMulti] = useState(false)

  const matchedProviderDetail = providers.find(p => p.info.name === storedWalletName)
  const ethereumProvider = matchedProviderDetail?.provider ?? window.ethereum
  const provider = new ethers.providers.Web3Provider(ethereumProvider)
  const signer = provider.getSigner()

  useEffect(() => {
    if (profile.guild_id !== NUMBER.ZERO) {
      getListItems()
    }
  }, [params, profile.guild_id])

  const openNotification = (message: string, description: string) => {
    notification.config({
      duration: NUMBER.FOUR
    })
    api.info({
      message,
      description,
      placement: 'bottomRight',
      className: message === STRING.ERROR ? 'ant-custom-error' : 'ant-custom-success'
    })
  }

  const getListItems = async () => {
    setLoading(true)
    const [error, result]: any = await handleAsyncRequest(itemApi.getTicketItems(params))
    if (error) {
      openNotification(STRING.ERROR, error.message || error.errors[0]?.message)
    }
    if (result) {
      const formatData = result.data.records.map((record: any) => {
        return {
          ...record,
          raceName: record.name,
          avatar: record.img,
          boost_type: record.type,
          inputAmount: '',
          isSelected: tokenIds.includes(record.id),
        }
      })
      setDataItems(formatData)
      setTotal(result.data?.total || NUMBER.ZERO)
    }

    setLoading(false)
  }

  useUpdateEffect(() => {
    setParams({ ...params, page: NUMBER.ONE })
  }, [])

  const memoizedResultListSelectionColumns = useMemo(() => {
    return guildDonateTicketColumns
  }, [profile])

  const transactionSuccess = () => {
    toggleOpenInProgressBalanceModal(false)
    notification.success({
      message: 'SUCCESS',
      description: `Donate successfully!`,
      placement: 'bottomRight',
      duration: 4,
      className: 'ant-custom-success'
    })
    dispatch(getTicketList({ guildId: profile.guild_id, params: defaultParams }))
  }

  const transactionFaild = (value: any) => {
    toggleOpenInProgressBalanceModal(false)
    notification.error({
      message: 'ERROR',
      description: value ?? 'Sorry! Your transaction has failed. Please go back and try again.',
      placement: 'bottomRight',
      duration: 4,
      className: 'ant-custom-error',
      icon: <></>
    })
  }

  const checkNonceContract = async (nonce: string) => {
    let checkNonceExits = null as any
    let x = 0
    const intervalID = setInterval(async () => {
      const [, result] = await handleAsyncRequest(guildApi.postCheckNonceGuildAdil({ nonce }))
      if (!result) return
      checkNonceExits = result.data.status
      if (checkNonceExits === STATUS_TRANSACTION.success) {
        clearInterval(intervalID)
        transactionSuccess()
        onConfirmDonate()
      }

      if (checkNonceExits === STATUS_TRANSACTION.expired) {
        clearInterval(intervalID)
        toggleOpenInProgressBalanceModal(false)
        transactionFaild(t(`${LENDING_MESSAGE}.failedTransaction`))
      }

      if (++x === 10) {
        if (checkNonceExits === STATUS_TRANSACTION.pending) {
          clearInterval(intervalID)
          toggleOpenInProgressBalanceModal(false)
          transactionFaild(t(`${NOTIFICATION_MESSAGE}.transferredPending`))
        }
      }
    }, timeCheckNonce)
  }

  const transactionContract = async (value: ResultDonate) => {
    if (!value) return
    try {
      const ethContract = new ethers.Contract(contract.tokenGuildVault, guildVaultABI.contract.abi, signer)
      try {
        const request: RequestDonate = {
          guildId: value.guild_id.toString(),
          itemIds: [],
          ticketIds: value.ticket_ids,
          ticketAmounts: value.ticket_amounts,
          adilAmount: ethers.utils.parseEther(value.adil_amount.toString()),
          blockExpired: value.block_expired.toString(),
          nonce: value.nonce,
          v: value.v,
          r: value.r,
          s: value.s
        }
        const tx = await ethContract.deposit(request)
        if (tx.hash) {
          setLoadingSubmit(false)
          checkNonceContract(value.nonce)
        }
      } catch (err: any) {
        setLoadingSubmit(false)
        transactionFaild(err?.error?.data?.message)
        toggleOpenInProgressBalanceModal(false)
      }
    } catch (err: any) {
      setLoadingSubmit(false)
      transactionFaild(err?.error?.data?.message)
      toggleOpenInProgressBalanceModal(false)
    }
  }

  const approveDonateNft = async (value: ResultDonate) => {
    try {
      if (!signer) return
      const itemNFTContract = new ethers.Contract(configs.ticketNft, ticketNftABI.contract.abi, signer)
      const gasPrice = convertGasPrice(+value.gas_price)
      try {
        const tx = await itemNFTContract.setApprovalForAll(configs.transporter, true,
          getGasPriceOption(gasPrice)
        )
        if (tx.hash) {
          const resultTransaction = await provider.waitForTransaction(tx.hash)
          if (resultTransaction.status) {
            transactionContract(value)
          } else {
            toggleOpenInProgressBalanceModal(false)
            transactionFaild(t(`${LENDING_MESSAGE}.failedTransaction`))
          }
        }
      } catch (err: any) {
        setLoadingSubmit(false)
        transactionFaild(err?.error?.data?.message)
      }
    } catch (err: any) {
      setLoadingSubmit(false)
      transactionFaild(err?.error?.data?.message)
    }
  }

  const handleConfirmSubmit = async () => {
    setLoadingSubmit(true)
    const payload = {
      tickets: tokenIds.map((id: number) => ({
        ticket_token: id,
        amount: Number(dataItems.find((item: any) => item.ticket_token === id)?.inputAmount ?? 0)
      })),
      guild_id: Number(profile?.guild_id)
    }
    const isWalletEnabled = await checkAnyWalletEnabled(storedWalletName as string);
    if (!isWalletEnabled) {
      setLoadingSubmit(false)
      removeDataAtLocalStorage()
      navigate(links.home.index())
      useReloadCurrentPage()
      return
    }
    const [error, result]: any = await handleAsyncRequest(guildApi.postDonateTicketNft(payload))
    if (error) {
      setLoadingSubmit(false)
      return
    }
    if (result) {
      toggleOpenInProgressBalanceModal(true)
      approveDonateNft(result.data)
    }
  }

  const handlePageClick = (event: any) => {
    setParams({ ...params, page: event.selected + 1 })
  }

  const isDisabledSave = useMemo(() => {
    if (!tokenIds.length) {
      return true
    }
    const isDisabled = dataItems?.some((item: any) => item.isSelected && !Number(item.inputAmount))
    return isDisabled
  }, [tokenIds, dataItems])

  const handleSave = () => {
    if (tokenIds?.length === 1) {
      setIsConfirm(true)
    } else {
      setIsConfirmMulti(true)
    }
  }

  return (
    <Modal>
      <ModalDonateTicketNftStyled>
        {contextHolder}
        <div className='donate-coin-modal'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          <div className='title-modal'>
            <div className={`color-primary`}>{t(`${GUILD_MESSAGE}.donateToGuildVault`)}</div>
            <img src={TWO_LINE} alt='' />
          </div>
          <div className='content-modal'>
            <div className='row line__guild--gradiant'>
              <img src={LINE_GUILD_GRADIENT} />
            </div>
            <div className='container'>
              <div>
                <RaceTable
                  columns={memoizedResultListSelectionColumns}
                  data={dataItems}
                  isHasMore={false}
                  raisePage={setParams}
                  loader={!loading}
                  params={params}
                  checkLoadingPage={false}
                  totalRace={total}
                  currentUser={profile}
                  noDataText={t(`${NOTIFICATION_MESSAGE}.dataNotFound`)}
                  isShowVipIcon={true}
                  onClickOneCell={id => {
                    const isExist = tokenIds.includes(id)
                    if (isExist) {
                      setTokenIds((prevs) => prevs.filter((token) => token !== id))
                    } else {
                      setTokenIds([
                        ...tokenIds,
                        id
                      ])
                    }
                    setDataItems((prevs: any) => {
                      return prevs.map((it: any) => ({
                        ...it,
                        isSelected: it.id === id ? !it.isSelected : it.isSelected,
                        inputAmount: it.id === id ? '' : it.inputAmount,
                      }))
                    })
                  }}
                  onChangeOneCell={(rowId, value) => {
                    const result = dataItems.map((item: any) => {
                      if (item.ticket_token === Number(rowId)) {
                        return {
                          ...item,
                          inputAmount: Number(value) > item.quantity ? item.quantity : value
                        }
                      }
                      return item
                    })
                    setDataItems(result)
                  }}
                />
              </div>
              <div className='pagination'>
                {dataItems.length > 0 && Number(total) > 10 && (
                  <div className='paginate'>
                    <ReactPaginate
                      nextLabel='>'
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={2}
                      pageCount={Math.ceil(Number(total) / params.limit)}
                      previousLabel='<'
                      pageClassName='page-item'
                      pageLinkClassName='page-link'
                      previousClassName='page-item'
                      previousLinkClassName='page-link'
                      nextClassName='page-item'
                      nextLinkClassName='page-link'
                      breakLabel='...'
                      breakClassName='page-item'
                      breakLinkClassName='page-link'
                      containerClassName='pagination'
                      activeClassName='active'
                      forcePage={params.page ? +params.page - 1 : 0}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className='actions-container'>
              <div className='balance-container'>
                <div className='donate'>
                  <div className='action'>
                    <Button
                      type='btnCancel'
                      buttonName={t(`${GUILD_MESSAGE}.cancel`)}
                      onClickButton={onCloseButtonClick}
                      width={147}
                    />
                    <Button
                      isLoading={loadingSubmit}
                      buttonName={t(`${GUILD_MESSAGE}.donate`)}
                      onClickButton={handleSave}
                      width={147}
                      disabled={isDisabledSave}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {openInProgressBalanceModal && <InProgressBalanceModal title={'DONATE IN PROGRESS'} />}
          {isConfirm && (
          <ModalConfirm
            onClose={() => setIsConfirm(false)}
            onConfirm={handleConfirmSubmit}
            titleModal='Confirm Donation'
            loading={loadingSubmit}
            content={
              <>
                <div className='content-confirm'>
                  <div>You’re donating {dataItems.find((it: any) => it.ticket_token === tokenIds?.[0])?.inputAmount}</div>
                  <div>
                    <img
                      width='25px'
                      height='25px'
                      style={{ objectFit: 'contain' }}
                      className='mr-2'
                      alt='Merah'
                      src={dataItems.find((it: any) => it.ticket_token === tokenIds?.[0])?.img}
                    />
                  </div>
                  <div>{dataItems.find((it: any) => it.ticket_token === tokenIds?.[0])?.name}</div>
                </div>
                <div>This can’t be undone.</div>
              </>
            }
            margingTop={true}
            widthM={550}
            heightM={250}
          />
        )}
        {isConfirmMulti && (
          <ModalConfirm
            onClose={() => setIsConfirmMulti(false)}
            onConfirm={handleConfirmSubmit}
            titleModal='Confirm Donation'
            loading={loadingSubmit}
            content={
              <>
                <div className='content-confirm'>
                  <div>You’re about to donate multiple items.</div>
                </div>
                <div>This can’t be undone.</div>
              </>
            }
            margingTop={true}
            widthM={550}
            heightM={250}
          />
        )}
      </ModalDonateTicketNftStyled>
    </Modal>
  )
}
